module.exports = {
    "id": "lava",
    "title": "lava",
    "image": "provision/parts/lava/lava.png",
    "info": [
      {
        "text": "Add some lava to your project",
        "image": "provision/parts/lava/lava.png"
      }
    ],
    "exposedVariables": [],
    "codeImage": "provision/parts/lava/lava.png"
  } ;